import { IconEye, IconEyeOff } from '@tabler/icons-react'
import {
  ComponentPropsWithoutRef,
  forwardRef,
  ReactNode,
  useState,
} from 'react'
import styles from '../../styles/common/Input.module.scss'
import BaseInput from './BaseInput'
import { Icon } from '../../assets/icons'

interface SignInInputProps extends ComponentPropsWithoutRef<'input'> {
  icon?: ReactNode
  isHide?: boolean
  isError?: boolean
}

const SignInInput = forwardRef<HTMLInputElement, SignInInputProps>(
  (
    {
      type = 'text',
      icon,
      isHide = false,
      isError = false,
      className,
      ...props
    },
    ref
  ) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false)

    const togglePasswordVisibility = () => {
      setIsPasswordVisible(!isPasswordVisible)
    }

    const inputType = type === 'password' && isPasswordVisible ? 'text' : type

    return (
      <div className={styles.signInInputContainer}>
        <div className={styles.signInInputWrapper}>
          {icon && <div className={styles.leftIcon}>{icon}</div>}

          <BaseInput
            ref={ref}
            type={inputType}
            isError={isError}
            className={`
              ${styles.input} 
              ${icon ? styles.withLeftIcon : ''} 
              ${isHide && type === 'password' ? styles.withRightIcon : ''}
              ${className || ''}
            `}
            {...props}
          />

          {isHide && type === 'password' && (
            <button
              type="button"
              className={styles.rightIcon}
              onClick={togglePasswordVisibility}
              aria-label={
                isPasswordVisible ? '비밀번호 숨기기' : '비밀번호 표시하기'
              }
            >
              {isPasswordVisible ? (
                <Icon name="eye" color="#C6C6C6" size={16} />
              ) : (
                <Icon name="eyeSlash" color="#C6C6C6" size={16} />
              )}
            </button>
          )}
        </div>
      </div>
    )
  }
)

SignInInput.displayName = 'SignInInput'

export default SignInInput
